module.exports = __webpack_public_path__ + "img/coe.41b129eb.jpg";